import dayjs from 'dayjs';
import { apiPostAuth } from '../../amplify/restClient';
import getSimulatedRepaymentSchedule from '../../redux/reducers/globalSelectors/loans/getSimulatedRepaymentSchedule';

export function parseTags(tags) {
  return typeof tags === 'string' ? JSON.parse(tags) : tags || {};
}

export function getTransactionSign(transaction) {
  const numericValue = [transaction?.accountCurrencyAmount, transaction?.quantity, transaction?.amount].find((value) => typeof value === 'number' && value !== 0);
  return numericValue && numericValue < 0 ? -1 : 1;
}

function sumByField(splitTransactions, field) {
  return splitTransactions.reduce((acc, curr) => acc + (Number(curr?.[field]) || 0), 0);
}

export function getAmountToSplitAbsolute({ currentTransaction, splitTransactions = [], isEditExistingSplitMode = false, currentTags = {} }) {
  let amountToSplitAbsolute = currentTransaction?.accountCurrencyAmount || currentTransaction?.transactionAmount || currentTransaction?.quantity || 0;
  if (isEditExistingSplitMode) amountToSplitAbsolute = sumByField(splitTransactions, 'accountCurrencyAmount');
  else if (currentTags?.loanRepayment) amountToSplitAbsolute = (Number(currentTags.loanRepayment.principal) || 0) + (Number(currentTags.loanRepayment.interest) || 0);
  return Math.abs(amountToSplitAbsolute);
}

export function getInitialRepaymentSplit({ currentTags = {}, splitTransactions = [], isEditExistingSplitMode = false, amountToSplitAbsolute = 0 }) {
  if (currentTags?.loanRepayment) {
    return {
      principal: Math.abs(Number(currentTags.loanRepayment.principal) || 0),
      interest: Math.abs(Number(currentTags.loanRepayment.interest) || 0),
    };
  }

  if (isEditExistingSplitMode) {
    return {
      principal: Math.abs(Number(splitTransactions.find((item) => item.label === 'investment-loanPrincipal')?.accountCurrencyAmount) || 0),
      interest: Math.abs(Number(splitTransactions.find((item) => item.label === 'investment-loanInterest')?.accountCurrencyAmount) || 0),
    };
  }

  return {
    principal: amountToSplitAbsolute,
    interest: 0,
  };
}

export async function fetchLoanRepaymentSplitFromDescription(description = '') {
  const response = await apiPostAuth('myAPI', 'misc/ai', {
    body: {
      message: description,
      mode: 'getInterestAndPrincipal',
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const { principal, interest } = response?.result || {};
  const isPrincipalNumber = typeof principal === 'number' && Number.isFinite(principal);
  const isInterestNumber = typeof interest === 'number' && Number.isFinite(interest);

  if (!isPrincipalNumber || !isInterestNumber) return null;
  return {
    principal: Math.abs(principal),
    interest: Math.abs(interest),
  };
}

export function getCalculatedInstallmentForCurrentMonth({ selectedLoanAccount, currentLoanBalance = 0 }) {
  if (!selectedLoanAccount) return null;

  const calculatedObject = getSimulatedRepaymentSchedule(dayjs.utc().startOf('month').valueOf(), currentLoanBalance, selectedLoanAccount, []);

  const requestedMonth = calculatedObject.schedule.find((item) => dayjs(item.date).isSame(dayjs.utc().startOf('month'), 'month'));
  return {
    interest: Math.abs(requestedMonth?.currentInterest || 0),
    principal: Math.abs(requestedMonth?.currentPrincipal || 0),
  };
}

export function sumSplitTransactionsField(splitTransactions = [], field) {
  return sumByField(splitTransactions, field);
}
